<template>
  <header class="dom-table-header">
    <span>{{ $t('trade.dom.order') }}</span>
    <span>{{ $t('trade.dom.buy') }}</span>
    <span
      v-tooltip.bottom="
        domScrollable
          ? $t('trade.dom.disable-scroll')
          : $t('trade.dom.enable-scroll')
      "
      :class="{ 'column-lock': !domScrollable }"
      @click="updateScrollLock"
    >
      {{ $t('trade.dom.price') }}
      <Icon v-if="domScrollable" name="unlock" />
      <Icon v-else name="lock" />
    </span>
    <span>{{ $t('trade.dom.sell') }}</span>
    <span>{{ $t('trade.dom.order') }}</span>
  </header>
</template>
<script>
import Icon from 'com/Icon'
import { UPDATE_DOM_SCROLLABLE } from 'store/mutation-types'
import { mapGetters } from 'vuex'
export default {
  name: 'DomTableHeader',
  components: {
    Icon
  },
  computed: {
    ...mapGetters(['domScrollable'])
  },
  methods: {
    updateScrollLock() {
      this.$store.commit(UPDATE_DOM_SCROLLABLE, !this.domScrollable)
    }
  }
}
</script>
<style lang="less">
.dom-table-header {
  align-items: flex-start;
  span {
    line-height: 1;
    &.column-lock {
      color: var(--active-color);
    }
    &:nth-of-type(3) {
      cursor: pointer;
    }
  }
  .icon {
    width: 8px;
    height: 10px;
    margin-left: 5px;
  }
}
</style>
